module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAiUlEQVQoU2NkQAKaJ+3imBiZva6a7Y+ACTPCGNqn7E3//2dKZmD4n87IxJBz1fTAVJAcWAFIkoGBKYWJ6X//378M1xkYmZIYGf9xgRQxQiVTmZj+9102OXBD66TD/2vmBxi1TjklMjL852TUOumQw8zMsAckCTINpgDMBitCA8gK4G5AVjMYFQAA+hFFQwHY5iIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort-up-green.png
// module id = IFZu
// module chunks = 2